import React from "react";
import { Link } from "react-router-dom";
import backgroundImage from "../assets/images/background.png";

const Home: React.FC = () => {
  return (
    <div className="bg-background min-h-screen">
      {/* Hero Section */}
      <div
        className="relative bg-gradient-to-r from-gradientFrom to-gradientTo text-white py-20 text-center px-6"
        style={{
          position: "relative",
        }}
      >
        <div style={{ position: "relative", zIndex: 2 }}>
          <h1 className="text-6xl font-semibold font-serif mb-6">
            Empower Your Insights
          </h1>
          <p className="text-lg font-sans max-w-2xl mx-auto">
            Unlock opportunities with our premium metadata solutions. From
            in-depth US Census insights to cutting-edge financial trends, we
            provide the data you need to make informed decisions. Explore our
            diverse offerings and discover the power of data-driven success.
          </p>
          <Link to="datasets">
            <button className="mt-8 bg-secondary text-gradientFrom font-semibold py-2 px-6 rounded-md shadow-md hover:bg-white transition">
              Explore Datasets
            </button>
          </Link>
        </div>
        {/* Background Image with Overlay */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${backgroundImage})`,
            opacity: 0.25,
          }}
        ></div>
      </div>

      {/* Features Section */}
      <div className="container mx-auto px-6 py-16">
        <h2 className="text-4xl font-serif text-center text-secondary mb-8">
          Why Choose Us?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Feature Cards */}
          {[
            {
              title: "Comprehensive Data Solutions",
              description:
                "Gain access to a vast collection of datasets, from detailed demographics and financial insights to the latest economic trends.",
              icon: "📊",
            },
            {
              title: "Accurate Insights",
              description:
                "Our data is meticulously curated to ensure reliability and relevance for your analysis.",
              icon: "✔️",
            },
            {
              title: "Seamless Integration",
              description:
                "Easily integrate our metadata into your tools and workflows via cloud-based marketplaces.",
              icon: "🔗",
            },
          ].map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md p-6 text-center hover:shadow-lg transform hover:scale-105 transition-all duration-300"
            >
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-serif text-primary mb-2">
                {feature.title}
              </h3>
              <p className="text-sm font-sans text-primary/70">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Call to Action */}
      <div className="bg-primary text-white text-center py-16">
        <h2 className="text-4xl font-serif mb-4">Ready to Get Started?</h2>
        <p className="text-lg font-sans max-w-2xl mx-auto mb-6">
          Join countless others leveraging our data to drive smarter decisions.
        </p>
        <Link to="contact">
          <button className="bg-accent py-2 px-6 rounded-md shadow-md hover:bg-accent/80 transition">
            Contact Us
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Home;
